import { Aufnahmebogen } from './Aufnahmebogen';
import { IDs } from '../../../helpers/IDs';

export class AufnahmebogenBerater extends Aufnahmebogen {

    protected dataIgnored: any = {};

    constructor(dataSheet: Array<any>, dataDb: any) {
        super(dataSheet, dataDb);

        if (dataSheet.length) {
            this.initData(IDs.ENT_SONSTIGE_DATEN);
            this.setJahre();
            this.setData();
        }
    }

    public getData(): Array<any> {
        const data: any = this.data;

        Object.keys(data).forEach((entity: any) => {
            data[entity] = this.getDataValided(data[entity]);
            const compare: Array<any> = this.dataIgnored[entity].map((item: any) => item.jahr);
            data[entity] = data[entity].filter((row: any) => compare.indexOf(row.jahr) === -1);
        });

        return data;
    }

    protected getDataValided(data: Array<any>): Array<any> {
        return data.filter((row: any) =>
            row.erfasst_von
            || row.institution
        );
    }

    private setData(): void {
        this.dataSheet.forEach((row: Array<string>, index: number) => {
            this.curRowIndex = index;
            const titel: string = this.getTitel() || null;

            if (index > 0) {
                this.setBemerkung();
            }

            switch (titel) {
                case 'Beratung/Erfassung erfolgte durch:':
                    this.setValue('erfasst_von');
                    break;
                case 'HWK/Institution/Firma':
                    this.setValue('institution');
                    break;
            }
        });
        this.setDataIgnored();
    }

    private setDataIgnored(): void {
        const entity: string = IDs.ENT_SONSTIGE_DATEN;
        const data: any = this.getDataValided(this.data[entity] || []);
        this.dataIgnored[entity] = [];

        data.forEach((row: any, index: number) => {
            const jahr: number = row.jahr || null;

            if (this.dataDb[entity].some((row: any) => row.jahr === jahr)) {
                this.dataIgnored[entity].push(data[index]);
            }
        });
    }
}
